import css from "styled-jsx/css";

export default css`
  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    :global(video),
    :global(.image) {
      object-fit: cover;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
`;
